import { type DateValue } from 'react-aria-components'

import { DatePicker } from '@components/designSystem/date-picker/date-picker'
import { LATEST_DAY, useSelectedDay } from '@hooks/useSelectedDay'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'
import { useStoreDays } from '@state/scans.ts'
import { calculateStoreDays } from '@utils/storeDays.ts'

function QuickDaySwitcher() {
  const { t } = useTypedTranslation()
  const { day, setDay } = useSelectedDay()
  const { data: days = [] } = useStoreDays()

  const { currentDay, previousDay, nextDay, minDay, maxDay, isDayAvailable } = calculateStoreDays(days, day ?? LATEST_DAY)

  function handleDaySelect(date: DateValue | null | undefined) {
    if (date) setDay(date.toString())
  }

  return <DatePicker
    aria-label={t('quickSelects.day.name')}
    value={currentDay ?? null}
    onChange={handleDaySelect}
    isDateUnavailable={date => !isDayAvailable(date)}
    minValue={minDay}
    maxValue={maxDay}
    preset={maxDay ? { label: t('quickSelects.day.latestPreset'), value: maxDay, onClick: () => setDay(LATEST_DAY) } : undefined}
    prevButton={{
      isDisabled: !previousDay,
      onClick: () => handleDaySelect(previousDay),
      ariaLabel: t('quickSelects.day.previousPreset'),
    }}
    nextButton={{
      isDisabled: !nextDay,
      onClick: () => handleDaySelect(nextDay),
      ariaLabel: t('quickSelects.day.nextPreset'),
    }}
  />
}

export default QuickDaySwitcher
